import $ from "jquery";

let Engage;

Engage = (() => {
  function Engage() {}

  $(".engage-something").on("click", function(e) {
    let $this;
    let theEngaged;
    e.preventDefault();
    $this = $(this);
    theEngaged = $this.attr("href");
    $(theEngaged).removeClass("hidden");
    $("html,body")
      .stop()
      .animate(
        {
          scrollTop: $(theEngaged).offset().top
        },
        500
      );
    return $this.addClass("hidden");
  });

  $(".toggle-something").on("click", function(e) {
    let $this;
    let theEngaged;
    e.preventDefault();
    $this = $(this);
    theEngaged = $this.attr("data-engage");
    $(theEngaged).toggleClass("hidden");
    return $(`*[data-engage="${theEngaged}"]`)
      .find("span")
      .toggleClass("hidden");
  });

  return Engage;
})();

export default new Engage();
